<template>
  <v-dialog v-model="dialog" width="900px">
    <v-card>
      <p class=".title ma-2">Email sent to the Sales partner</p>
      <v-form ref="showIpfcEmailss">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
                v-for="(mail, i) in ipfc.mail"
                :key="i"
                @click="$router.open('/mail/showMail/' + mail.mail_encrid)"
              >
                <td>{{ mail.mail_dt }}</td>
                <td>{{ mail.mail_oms }}</td>
                <td>{{ mail.mail_to }}</td>
                <td>
                  <v-chip :color="mail.mlrc_id" text-color="white">
                    <v-avatar left>
                      <v-icon v-if="mail.mlrc_id === 'success'"
                        >mdi-checkbox-marked-circle</v-icon>
                      <v-icon v-else
                        >mdi-close-circle</v-icon>  
                    </v-avatar>
                    {{ mail.mlrc_dt }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      ipfc_encrid: null,
      ipfc: {},
    }
  },
  methods: {
    open(ipfc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/getIpfcEmails.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIpfcEmails",
          },
          getIpfcEmails: {
            ipfc_encrid: ipfc_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.ipfc = res.data.getIpfcEmails;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

